<template>
  <v-card class="mb-1" outlined>
    <v-row class="ma-0 py-1 px-1" align="center" no-gutters style="flex-wrap: nowrap;">
      <v-col cols="1" class="py-0 px-1">
        <div class="readonly-field-label text-caption primary--text">
          {{ $t('label.documentNumber') }}
        </div>
        <div class="font-weight-bold mt-1" style="font-size: 1rem; letter-spacing: 0.3px;">
          {{ houseBl.documentNbr }}
        </div>
      </v-col>

      <v-divider vertical/>

      <v-col cols="3" class="py-0 px-2 d-flex align-center justify-center">
        <v-row>
          <v-col class="py-0 px-2 text-caption" style="min-width: 0;">
            <ReadonlyField :label="$t('label.shipper')" :value="houseBl.shipperName"
                           class="compact-field truncate-text"/>
          </v-col>
          <v-col class="py-0 px-2 text-caption" style="min-width: 0;">
            <ReadonlyField :label="$t('label.consignee')" :value="houseBl.consigneeName"
                           class="compact-field truncate-text"/>
          </v-col>
        </v-row>
      </v-col>

      <v-divider vertical/>

      <v-col cols="3" class="py-0 px-2 d-flex align-center justify-center">
        <v-row>
          <v-col class="py-0 px-2 text-caption" style="min-width: 0;">
            <ReadonlyField :label="$t('label.clientFm')" :value="houseBl.clientFmName"
                           class="compact-field truncate-text"/>
          </v-col>
          <v-col class="py-0 px-2 text-caption" style="min-width: 0;">
            <ReadonlyField :label="$t('label.clientTo')" :value="houseBl.clientToName"
                           class="compact-field truncate-text"/>
          </v-col>
        </v-row>
      </v-col>

      <v-divider vertical/>

      <v-col cols="1" class="py-0 px-2 d-flex align-center justify-center">
        <v-row>
          <v-col cols="10" class="py-0 px-2 text-caption">
            <ReadonlyField :label="$t('label.billOfLading')" :value="houseBl.billOfLading"
                           class="compact-field truncate-text"/>
          </v-col>
        </v-row>
      </v-col>

      <v-divider vertical/>

      <v-col cols="4" class="py-0 px-2 d-flex align-center justify-center">
        <v-row class="ma-0" align="center" justify="center" style="flex-wrap: nowrap; width: 100%;">

          <v-col cols="3" class="pa-1 d-flex flex-column align-center">
            <v-avatar size="36" style="border: 2px solid var(--v-primary-base)">
              <v-icon size="18" color="primary">mdi-ferry</v-icon>
            </v-avatar>
            <span class="location-label mt-1">{{ houseBl.masterBl.polLabel }}</span>
          </v-col>

          <v-col cols="5" class="pa-0 d-flex flex-column align-center">
            <div class="d-flex align-center" style="width: 100%;">
              <v-divider/>
              <v-icon size="12" color="primary" style="flex-shrink: 0;">mdi-navigation-variant</v-icon>
              <v-divider/>
            </div>
            <span class="vessel-name mt-1">{{ houseBl.masterBl.vesselName }}</span>
          </v-col>

          <v-col cols="3" class="pa-1 d-flex flex-column align-center">
            <v-avatar size="36" style="border: 2px solid var(--v-primary-base)">
              <v-icon size="18" color="primary">mdi-ferry</v-icon>
            </v-avatar>
            <span class="location-label mt-1">{{ houseBl.masterBl.podLabel }}</span>
          </v-col>

          <v-divider vertical/>

          <v-col cols="auto" class="pa-0 d-flex ml-4" style="min-width: 40px;">
            <v-btn icon small color="primary" @click="goToHouseBL">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

    </v-row>
  </v-card>
</template>

<script>
import {mapState} from 'vuex'
import {dateFilter} from '@/filters/dateFilter'
import ReadonlyField from '@/components/elements/ReadonlyField.vue'

export default {
  name: 'HouseBLRow',
  props: ['houseBl'],
  components: {ReadonlyField},
  data() {
    return {}
  },
  computed: {
    ...mapState('account', ['isAdmin', 'internalVisibilityAuth']),
    createDate() {
      return dateFilter.formatDateDayShort(this.houseBl.createDate)
    },
    updateDate() {
      return dateFilter.formatDateDayShort(this.houseBl.updateDate)
    },
    selected() {
      return this.currentSelection.includes(this.houseBl)
    },
    equipmentList() {
      if (!this.houseBl?.containers?.length) return ''

      return this.houseBl.containers
          .map(c => c.equipmentReference)
          .filter(Boolean)
          .join(', ')
    }
  },
  methods: {
    goToHouseBL() {
      this.$router.push({
        name: 'houseBl',
        params: {id: this.houseBl.id},
      })
    },
  },
}
</script>

<style scoped>
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.compact-field {
  min-width: 0;
}

.readonly-field-label {
  text-transform: uppercase;
  font-size: 0.65rem !important;
  letter-spacing: 0.05em;
  font-weight: 500;
  color: #78909C;
  margin-bottom: 2px;
}

.location-label {
  max-width: 150px;
  text-align: center;
  font-size: 0.68rem;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.6);
  white-space: normal;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.vessel-name {
  max-width: 200px;
  font-size: 0.68rem;
  text-align: center;
  white-space: normal;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  color: var(--v-primary-base);
  font-weight: 500;
}
</style>